<template>
  <div
    class="form-group multipleSelect"
    :class="{
      'has-error': title != undefined && errors[title] != undefined,
      focused: open || (modelValue != null && modelValue.length > 0),
    }"
    @keyup="test"
    v-clickOutside="close"
  >
    <Field
      type="text"
      :as="as"
      :id="uid"
      :name="title"
      class="form-control"
      :class="{
        'parsley-error': errors[title] != undefined,
      }"
      v-model="inputValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :rules="rules"
      readonly
      @focus="open = true"
    />
    <label class="control-label" :for="uid" v-if="title != undefined"
      >{{ title }}
    </label>
    <i
      class="fas fa-times-circle pointer clear"
      v-if="model.length > 0"
      @click="clear()"
    ></i>
    <div class="drop" :class="{ open: open }">
      <div class="search">
        <input
          type="text"
          class="form-control"
          placeholder="Ara..."
          ref="search"
          v-model="search"
          @focus="isSearchFocus = true"
          @blur="isSearchFocus = false"
        />
      </div>
      <ul>
        <li
          @click="
            selectAll = !selectAll;
            setSelectAll();
          "
        >
          <div class="myCheckBox">
            <input type="checkbox" class="filled-in" :checked="selectAll" />
            <label>{{ selectAll ? "Hepsini Çıkar" : "Hepsini Seç" }}</label>
          </div>
        </li>
        <li
          v-for="item in data"
          :key="item.value"
          @click="setValue(item.value)"
          v-show="item.title.toLowerCase().indexOf(search.toLowerCase()) > -1"
        >
          <div class="myCheckBox">
            <input
              type="checkbox"
              class="filled-in"
              :checked="model != null && model.indexOf(item.value) > -1"
            />
            <label>{{ item.title }}</label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "multiSelect",
  props: ["modelValue", "errors", "title", "data", "rules", "as"],
  data() {
    return {
      uid: this.$uniqueid(),
      model: this.modelValue,
      open: false,
      inputValue: "",
      search: "",
      isSearchFocus: false,
      selectAll: false,
    };
  },
  created() {
    this.setValue();
  },
  watch: {
    open() {
      if (this.open) {
        this.search = "";
        this.$refs.search.focus();
      }
      this.data
        .filter(
          (x) => x.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        )
        .forEach((element) => {
          if (this.model.indexOf(element.value) == -1) {
            this.selectAll = false;
          }
        });
    },
    modelValue() {
      this.model = this.modelValue;
      let text = "";
      this.data
        .filter((x) => this.model.indexOf(x.value) > -1)
        .forEach((element) => {
          text += ", " + element.title;
        });
      this.inputValue = text.replace(", ", "");
    },
    search() {
      let select = true;
      this.data
        .filter(
          (x) => x.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        )
        .forEach((element) => {
          if (this.model.indexOf(element.value) == -1) {
            select = false;
          }
        });
      this.selectAll = select;
    },
  },
  methods: {
    close() {
      this.open = false;
    },
    setValue(value) {
        console.log("setValue", this.data,this.model,this.data
        .filter((x) => this.model.indexOf(x.value) > -1));
      if (value != undefined) {
        if (this.model.indexOf(value) == -1) {
          this.model.push(value);
        } else {
          this.model = this.model.filter((x) => x != value);
        }
      }
      let text = "";
      this.data
        .filter((x) => this.model.indexOf(x.value) > -1)
        .forEach((element) => {
          text += ", " + element.title;
        });
      this.inputValue = text.replace(", ", "");
      this.$emit("update:modelValue", this.model);
    },
    test(e) {
      if (!this.isSearchFocus && e.key.length == 1) {
        this.search = this.search += e.key;
      }
      this.$refs.search.focus();
    },
    clear() {
      this.model = [];
      this.inputValue = [];
      this.$emit("update:modelValue", this.inputValue);
    },
    setSelectAll() {
      let data = [];
      if (this.selectAll) {
        this.data
          .filter(
            (x) => x.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          )
          .forEach((element) => {
            data.push(element.value);
          });
      }
      this.model = data;
      let text = "";
      this.data
        .filter((x) => this.model.indexOf(x.value) > -1)
        .forEach((element) => {
          text += ", " + element.title;
        });
      this.inputValue = text.replace(", ", "");
      this.$emit("update:modelValue", this.model);
    },
  },
};
</script>

<style></style>
